import { colors, spacing, radius, typography } from '../tokens';
export const inputStyles = {
    base: {
        width: '100%',
        padding: spacing[3],
        fontSize: typography.fontSize.md,
        border: `1px solid ${colors.gray[300]}`,
        borderRadius: radius.md,
        outline: 'none',
        transition: 'border-color 0.2s',
    },
    focused: {
        borderColor: colors.primary[500],
    },
    error: {
        borderColor: colors.error.DEFAULT,
    },
    disabled: {
        backgroundColor: colors.gray[50],
        cursor: 'not-allowed',
    },
};
export const labelStyles = {
    base: {
        fontSize: typography.fontSize.base,
        fontWeight: typography.fontWeight.medium,
        color: colors.gray[700],
        fontFamily: typography.fontFamily.sans,
    },
};
export const errorTextStyles = {
    base: {
        fontSize: typography.fontSize.sm,
        color: colors.error.DEFAULT,
        marginTop: spacing[1],
    },
};
//# sourceMappingURL=input.js.map